import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import host from "../global";

const SourcingConfigContext = createContext({ sourcingEnabled: false, loading: true });

export function SourcingConfigProvider({ children }) {
  const [sourcingEnabled, setSourcingEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const accessToken = sessionStorage.getItem("accessToken");

  useEffect(() => {
    let cancelled = false;

    const fetchConfig = async () => {
      try {
        const response = await axios.get(`${host}/get_configurations`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (!cancelled) setSourcingEnabled(response.data?.sourcing_enabled === true);
      } catch (error) {
        console.error("Error fetching sourcing configuration:", error);
        if (!cancelled) setSourcingEnabled(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    if (accessToken) {
      fetchConfig();
    } else {
      setLoading(false);
    }

    return () => {
      cancelled = true;
    };
  }, [accessToken]);

  return (
    <SourcingConfigContext.Provider value={{ sourcingEnabled, loading }}>
      {children}
    </SourcingConfigContext.Provider>
  );
}

export function useSourcingConfig() {
  return useContext(SourcingConfigContext);
}
